<template>
    <d-form class="main-navbar__search w-100 d-none d-md-flex d-lg-flex">
        <label class="ml-3 mt-3">
            {{ version }}
        </label>
        <!-- <d-input-group class="ml-3" seamless>
            <d-input-group-text slot="prepend">
                <i class="material-icons">search</i>
            </d-input-group-text>
            <d-input class="navbar-search" placeholder="Search for something..." />
        </d-input-group> -->
    </d-form>
</template>
<script>
import Push from 'push.js'

export default {
    data(){
        return{
            version:''
        }
    },
    mounted() {
        this.checkVersion()
    },
    methods: {
        checkVersion() {
            fetch("/version.json", { cache: "no-cache" })
                .then((response) => response.json())
                .then((data) => {
                    const version = data.version;
                    this.version = version
                })
        }
    },

};
</script>